// extracted by mini-css-extract-plugin
export default {"underwriting_container":"underwriting_underwriting_container__rApY-","underwriting_task_board_container":"underwriting_underwriting_task_board_container__PKtuj"};